// export const BASE_URL = "http://localhost:8000";
// export const BASE_URL = "https://kama-club-be-arb0dxajg4azeafp.ukwest-01.azurewebsites.net";
// export const BASE_URL = "https://kamaiclub-gbdyg4hyewagh2g9.ukwest-01.azurewebsites.net";
// export const BASE_URL = "https://kamaiclib-be-node-mnaa.onrender.com";
// export const BASE_URL = "https://backend-production-2aaf.up.railway.app";

export const BASE_URL = "https://backend-3mtp.onrender.com";
